import { render, staticRenderFns } from "./Input_Checkbox.vue?vue&type=template&id=dc16adaa&scoped=true&"
import script from "./Input_Checkbox.vue?vue&type=script&lang=js&"
export * from "./Input_Checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc16adaa",
  null
  
)

export default component.exports